export default __webpack_public_path__ + "static/media/sonospine_logo.415659d4.png";